
import styled from "./footer.module.css"
function Footer() {
    return(
    <div className={styled.footer}>
        <h3>
اطلاعات تماس
<br></br>
 email: nastaran.evaznia@gmail.com
        </h3>
    </div>
    );
}
export default Footer